import BaseLayout from "@/layout/BaseLayout.vue";
import Layout2 from '@/pages/Programma.vue' //Programma
import Layout2_1 from '@/pages/CategoriePost.vue' //Category with posts
import Layout1 from '@/pages/ArticoloProgramma.vue' //Articolo

export default [
   {
      path: '/s3',
      name: 's3',
      component: BaseLayout,
      props:true,
      meta:{         
         layout: Layout2,
         params: true,
         props: true,
         breadcrumb:{
           label: 'S3', 
           parent: 'Home'
         }      
      },
      children: [    
               {
            path: 'cos-e-la-s3',
            meta:{  
               layout: Layout1,
               params: true,
               area: "S3",
               breadcrumb() {

                  const label = this.$route.params.article !== undefined ? this.$route.params.article : "Cos'è la S3";
                  return {
                     label: label[0].toUpperCase() + label.slice(1).replaceAll('-', ' ')
                  };
               }
            }
         },        
         {
            path: 'la-politica-di-coesione',
            meta:{  
               layout: Layout1,
               params: true,
               area: "S3",
               breadcrumb() {

                  const label = this.$route.params.article !== undefined ? this.$route.params.article : "La politica di coesione";
                  return {
                     label: label[0].toUpperCase() + label.slice(1).replaceAll('-', ' ')
                  };
               }
            }
         },
         {
            path: 'glossario-minimo-s3',
            meta:{
               layout: Layout1,
               params: true,
               area: "S3",
               breadcrumb() {

                  const label = this.$route.params.article !== undefined ? this.$route.params.article : "Glossario minimo S3";
                  return {
                     label: label[0].toUpperCase() + label.slice(1).replaceAll('-', ' ')
                  };
               }
            }
         },
         {            
            path: ':slug',
            name: 'subcategory',
            area: 's3',
            meta:{         
               layout: Layout2_1,
               params: true,
               props: true,
               parent: 's3',
               breadcrumb() {
                  const label = this.$route.params.title && !this.$route.params._slug ? this.$route.params.title : this.$route.params.slug;
                  return {
                     label: label[0].toUpperCase() + label.slice(1).replaceAll('-', ' ')
                  };
               }    
            },

            children: [
               {
                  path: ':_slug',
                  alias: 'articolo-programma',
                  name: 'articolo-s3',               
                  meta:{  
                     layout: Layout1,
                     params: true,
                     props: true,
                     breadcrumb() {
                        const label = this.$route.params.title !== undefined ? this.$route.params.title : this.$root.title;
                        return {
                           label: label
                        };
                     }                       
                  },

                  children: [
                     {
                        path: ':__slug',
                        name: 'articolo-child',                                        
                        meta:{  
                        layout: Layout1,
                        params: true,
                        props: true,
                           breadcrumb() {
                              const label = this.$route.params.title !== undefined ? this.$route.params.title : this.$root.title;
                              return {
                              label: label
                           };
                        }                       
                        }
                     }
                  ],
               }
            ]
         },
      ]     
   },  
];
